// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { flowController } from "../../../game_theme/flow_fb/flowController";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentContainer } from "../../framework/components/ComponentContainer";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { DialogSettings } from "../../settings/Settings";
import { AngryAnalytics } from "../Analytics/Analytics";
import { s_black_square, s_popup_darkblue_rect, s_popup_top, s_popup_bottom, s_popup_close, s_icon_close, s_btn_orange } from "../AssetDefinitions/ImageDefinitions";
import { EventSystem } from "../Events/EventSystem";
import { Events } from "../Events/Events";
import { ConfirmationDialog } from "./ConfirmationDialog";
import { LoadingOverlay } from "./LoadingOverlay";
import { WarningDialog } from "./WarningDialog";
import { tgfHooks } from "../../framework/hooks/hooks";
tgfSettings.dialogDefaults.PlayerRightsDialog = {
    width: 800,
    height: 650,
    font: DialogSettings.textFont,
    buttonFont: DialogSettings.buttonFont,
    components: [] // The additional components to add
};
export var PlayerRightsDialog = function (properties) {
    "use strict";
    this.name = "PlayerRightsDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.PlayerRightsDialog);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    this.onDisconnect = this.close.bind(this, false);
    EventSystem.subscribe(Events.DISCONNECTED, this.onDisconnect);
};
// Inherit the base dialog
tgfDialogs.inherit(PlayerRightsDialog, DialogBase);
PlayerRightsDialog.prototype.doPrepare = function () {
    "use strict";
    var self = this;
    this.transparentBlack = new ComponentButton({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0.7,
        image: s_black_square
    });
    this.addComponent(this.transparentBlack);
    this.background = new ComponentPicture({
        image: s_popup_darkblue_rect,
        createFromSlices: true,
        sliceMarginsArray: [55, 55, 55, 55],
        width: this.width,
        height: this.height,
        x: -(this.width / 2),
        y: -(this.height / 2)
    });
    this.transparentBlack.addComponent(this.background);
    this.headerBackground = new ComponentPicture({
        image: s_popup_top,
        x: tgfGraphics.areaWidth / 2,
        y: -this.height / 2 + tgfGraphics.areaHeight / 2
    });
    this.addComponent(this.headerBackground);
    this.addComponent(new ComponentPicture({ image: s_popup_bottom, x: tgfGraphics.areaWidth / 2, y: this.height / 2 - 20 + tgfGraphics.areaHeight / 2 }));
    this.headerLabel = new ComponentLabel({
        text: tgfDictionary.getText("BTN_PLAYER_RIGHTS"),
        font: this.font,
        y: 4
    });
    this.headerBackground.addComponent(this.headerLabel);
    this.closeButton = new ComponentButton({
        image: s_popup_close,
        icon: s_icon_close,
        x: this.width / 2 + 5,
        y: 33,
        onClick: this.close.bind(this)
    });
    this.headerBackground.addComponent(this.closeButton);
    this.buttonContainer = new ComponentContainer({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2
    });
    this.addComponent(this.buttonContainer);
    this.viewPlayerDataButton = new ComponentButton({
        image: s_btn_orange,
        y: -210,
        text: tgfDictionary.getText("BTN_VIEW_PLAYER_DATA"),
        fontUp: this.buttonFont,
        onClick: this.viewPlayerData.bind(this)
    });
    // this.buttonContainer.addComponent(this.viewPlayerDataButton);
    this.viewGameDataButton = new ComponentButton({
        image: s_btn_orange,
        y: -100,
        text: tgfDictionary.getText("BTN_VIEW_GAME_DATA"),
        fontUp: this.buttonFont,
        onClick: this.viewGameData.bind(this)
    });
    // this.buttonContainer.addComponent(this.viewGameDataButton);
    this.deletePlayerDataButton = new ComponentButton({
        image: s_btn_orange,
        y: 10,
        text: tgfDictionary.getText("BTN_DELETE_PLAYER_DATA"),
        fontUp: this.buttonFont,
        onClick: this.deletePlayerData.bind(this)
    });
    // this.buttonContainer.addComponent(this.deletePlayerDataButton);
    this.deleteGameDataButton = new ComponentButton({
        image: s_btn_orange,
        y: 120,
        text: tgfDictionary.getText("BTN_DELETE_GAME_DATA"),
        fontUp: this.buttonFont,
        onClick: this.deleteGameData.bind(this)
    });
    // this.buttonContainer.addComponent(this.deleteGameDataButton);
    var playerIDText = new ComponentLabel({
        text: "PLAYER ID:",
        font: this.font,
        y: -150
    });
    this.buttonContainer.addComponent(playerIDText);
    var playerID = new ComponentLabel({
        text: tgfHooks.getPlayerID(),
        font: this.font,
        y: -100
    });
    this.buttonContainer.addComponent(playerID);
    this.legalTextButtonContainer = new ComponentContainer({
        y: 10
    });
    this.buttonContainer.addComponent(this.legalTextButtonContainer);
    this.tosButton = new ComponentButton({
        image: s_btn_orange,
        text: tgfDictionary.getText("BTN_TOS"),
        fontUp: this.buttonFont,
        onClick: function () {
            AngryAnalytics.reportUXButtonOpen("terms_privacy");
            AngryAnalytics.reportScreen("terms_privacy");
            window.open(flowController.getRovioLink());
        }
    });
    this.legalTextButtonContainer.addComponent(this.tosButton);
    AngryAnalytics.reportUXButtonOpen("player_rights");
    AngryAnalytics.reportScreen("player_rights");
};
PlayerRightsDialog.prototype.close = function (callOnClose) {
    this.hide();
    this.free();
    EventSystem.unsubscribe(Events.DISCONNECTED, this.onDisconnect);
    if (this.onClose && callOnClose) {
        this.onClose();
    }
    AngryAnalytics.reportUXButtonClose("player_rights");
};
PlayerRightsDialog.prototype.toggleInput = function (enable) {
    if (enable) {
        this.activate();
    }
    else {
        this.deactivate();
    }
};
PlayerRightsDialog.prototype.viewPlayerData = function () {
    AngryAnalytics.reportUXButtonOpen("view_player_data");
    AngryAnalytics.reportScreen("view_player_data");
    if (tgfHooks.getDevice()["device"] != "webplayer") {
        var warning = new WarningDialog({
            text: tgfDictionary.getText("ONLY_ON_DESKTOP_BODY_TEXT")
        });
        warning.show();
    }
    else {
        window.open(flowController.getRovioLink());
    }
};
PlayerRightsDialog.prototype.viewGameData = function () {
    var self = this;
    AngryAnalytics.reportUXButtonOpen("view_game_data");
    AngryAnalytics.reportScreen("view_game_data");
    if (tgfHooks.getDevice()["device"] != "webplayer") {
        var warning = new WarningDialog({
            text: tgfDictionary.getText("ONLY_ON_DESKTOP_BODY_TEXT")
        });
        warning.show();
    }
    else {
    }
};
PlayerRightsDialog.prototype.deletePlayerData = function () {
    AngryAnalytics.reportUXButtonOpen("delete_player_data");
    if (tgfHooks.getDevice()["device"] != "webplayer") {
        var warning = new WarningDialog({
            text: tgfDictionary.getText("ONLY_ON_DESKTOP_BODY_TEXT")
        });
        warning.show();
    }
    else {
        window.open(flowController.getRovioLink());
    }
};
PlayerRightsDialog.prototype.deleteGameData = function () {
    AngryAnalytics.reportUXButtonOpen("delete_game_data");
    var confirm = new ConfirmationDialog({
        headerText: tgfDictionary.getText("DELETE_GAME_DATA_HEADER"),
        bodyText: tgfDictionary.getText("DELETE_GAME_DATA_BODY_TEXT"),
        buttonText: tgfDictionary.getText("BTN_DELETE_GAME_DATA_POPUP"),
        onAccept: function () {
            AngryAnalytics.reportPlayerConfirm("delete_game_data");
            var loadingOverlay = new LoadingOverlay({
                x: tgfGraphics.areaWidth / 2,
                y: tgfGraphics.areaHeight / 2,
                text: "WAIT_TEXT"
            });
            loadingOverlay.show();
            flowController.removeConnectionListeners();
            // gamesBackendService.removePlayerFromServer().then(function() {
            //     tgfHooks.saveGdprData({ "gdpr": false }, function(){
            //         loadingOverlay.hide();
            //         loadingOverlay.free();
            //         tgfHooks.gameOver();
            //     },function(){
            //         console.log("save Error");
            //     });
            // }).catch(function(reason) {
            //     console.log("rejected with reason: " + reason);
            // });
        },
        onDecline: function () {
            AngryAnalytics.reportUXButtonClose("delete_game_data");
        },
    });
    confirm.show();
    AngryAnalytics.reportScreen("delete_game_data");
};
PlayerRightsDialog.prototype._download = function (content, fileName, contentType) {
    var a = document.createElement("a");
    var file = new Blob([content], { type: contentType });
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
};
